(() => {
  const url = new URL(window.location.href);
  const loader = document.getElementById('mm-uk-reverse-route-loader');
  if (!loader?.dataset.themeId || loader.dataset.themeId !== loader.dataset.candidateId) return;
  const previewTest = loader.dataset.themeRole === 'unpublished' && url.searchParams.get('mm_reverse_test') === '1';
  if (loader.dataset.themeRole !== 'main' && !previewTest) return;
  if (url.protocol !== 'https:' || url.hostname !== 'moomenn.co.uk') return;
  if (!previewTest && ['preview_theme_id', 'pb', '_ab'].some((key) => url.searchParams.has(key))) return;
  if (/bot|crawl|spider|slurp|facebookexternalhit|twitterbot/i.test(navigator.userAgent)) return;
  if (/^\/(cart|checkout|checkouts|account|customer_authentication|password)(\/|$)/i.test(url.pathname)) return;
  if (/^\/apps\//i.test(url.pathname)) return;

  // These 17 countries have recorded US-store Market membership and routes.
  // Do not guess a destination for countries outside those Markets.
  const destinations = Object.freeze({
    US: 'https://moomenn.com/',
    FR: 'https://moomenn.fr/',
    DE: 'https://moomenn.de/de/',
    BE: 'https://moomenn.be/',
    NL: 'https://moomenn.nl/nl/',
    AT: 'https://moomenn.com/en-eu/',
    DK: 'https://moomenn.com/en-eu/',
    FI: 'https://moomenn.com/en-eu/',
    IE: 'https://moomenn.com/en-eu/',
    IT: 'https://moomenn.com/en-eu/',
    LU: 'https://moomenn.com/en-eu/',
    NO: 'https://moomenn.com/en-eu/',
    PL: 'https://moomenn.com/en-eu/',
    PT: 'https://moomenn.com/en-eu/',
    ES: 'https://moomenn.com/en-eu/',
    SE: 'https://moomenn.com/en-eu/',
    CH: 'https://moomenn.com/en-eu/'
  });
  const preferenceKey = 'moomenn-stay-uk-this-tab';
  const fromSameStore = (() => {
    try { return !!document.referrer && new URL(document.referrer).origin === url.origin; }
    catch (_) { return false; }
  })();
  try {
    // Retire the former permanent choice; an explicit choice now lasts one tab.
    localStorage.removeItem('moomenn-stay-uk');
    if (url.searchParams.get('mm_auto') === '1') sessionStorage.removeItem(preferenceKey);
    else if (url.searchParams.get('mm_stay_uk') === '1') sessionStorage.setItem(preferenceKey, '1');
    else if (performance.getEntriesByType('navigation')[0]?.type === 'navigate' && !fromSameStore) {
      // A fresh direct/external arrival uses location again; internal shopping retains the choice.
      sessionStorage.removeItem(preferenceKey);
    }
    if (sessionStorage.getItem(preferenceKey) === '1') return;
  } catch (_) { return; }

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      const country = data?.detected_values?.country?.handle;
      if (!Object.prototype.hasOwnProperty.call(destinations, country)) return;
      try {
        if (sessionStorage.getItem(preferenceKey) === '1') return;
      } catch (_) { return; }
      // Separate catalogues: never transfer a UK path, cart, search or query.
      let destination = destinations[country];
      if (country === 'BE') {
        const language = (navigator.languages || [navigator.language || ''])
          .map((value) => String(value).toLowerCase().split('-')[0])
          .find((value) => value === 'fr' || value === 'nl');
        if (language) destination += language + '/';
      }
      window.location.assign(destination);
    })
    .catch(() => {});
})();
